import * as React from 'react';
import styles from './index.less';
import ToTopBtnStore from './store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';

const ToTopBtn = ({ store, className, targetId = 'main' }) => {
  store.use();
  return (
    <div
      className={cx(styles.toTopBtn, className, store.isActive && styles.toTopBtnAct)}
      ref={store.btnRef}
      onClick={() => {
        store.scrollToTop(targetId);
      }}
    />
  );
};

export default wrapStore(ToTopBtn, ToTopBtnStore);
